export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref11900.583bec65.jpg";